import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="m14.575 5.625-8.75 8.75m8.75-1.042a1.042 1.042 0 1 1-2.083 0 1.042 1.042 0 0 1 2.083 0ZM7.909 6.667a1.042 1.042 0 1 1-2.084 0 1.042 1.042 0 0 1 2.084 0Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);